/** Declarative point inside the visual box, independent of collision authority.
 * Coordinates are normalized, x rightward and y downward. */
export type PresentationAnchor = 'center' | 'bottom' | 'top-left' | { x: number; y: number };
export interface PresentationVisualBounds { x:number; y:number; w:number; h:number; }

/** Convert a subject-relative point into the full texture's normalized origin.
 * Invalid legacy data falls back to the existing image anchor; publication
 * validators reject it. Mirroring applies only to the opt-in subject bounds. */
export function presentationTextureAnchor(anchor?:PresentationAnchor,bounds?:PresentationVisualBounds,flipped=false):{x:number;y:number}{
  const point=normalizedPresentationAnchor(anchor);
  if(!bounds||![bounds.x,bounds.y,bounds.w,bounds.h].every(Number.isFinite)||bounds.x<0||bounds.y<0
    ||bounds.w<=0||bounds.h<=0||bounds.x+bounds.w>1||bounds.y+bounds.h>1)return point;
  const x=bounds.x+point.x*bounds.w;
  return {x:flipped?1-x:x,y:bounds.y+point.y*bounds.h};
}

/** Runtime clamp also protects consumers of legacy/unvalidated source objects.
 * This allocates only at revision time, never during animation sampling. */
export function normalizedPresentationAnchor(anchor?: PresentationAnchor): { x: number; y: number } {
  if (anchor === 'bottom') return { x: 0.5, y: 1 };
  if (anchor === 'top-left') return { x: 0, y: 0 };
  if (anchor === undefined || anchor === 'center') return { x: 0.5, y: 0.5 };
  const unit = (n: number) => Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : 0.5;
  return { x: unit(anchor.x), y: unit(anchor.y) };
}
